import { useActionOutputs } from 'automation-ui-action-features/action-outputs/actionOutputHooks';
import { getActionOutputsForTargetActionById } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
export const useGetActionOutputsForTargetActionById = flow => {
  const {
    instanceOutputsByActionId,
    allOutputsByActionTypeId
  } = useActionOutputs(flow.toHybridFlowInterface());
  return (targetActionId, isNewAction) => getActionOutputsForTargetActionById({
    flow,
    allOutputsByActionTypeId,
    instanceOutputsByActionId,
    targetActionId,
    isNewAction
  });
};